import { render } from "./PasarelaRegistro.vue?vue&type=template&id=37976bc2&scoped=true"
import script from "./PasarelaRegistro.vue?vue&type=script&lang=js"
export * from "./PasarelaRegistro.vue?vue&type=script&lang=js"

import "./PasarelaRegistro.vue?vue&type=style&index=0&id=37976bc2&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37976bc2"]])

export default __exports__